import React from "react";
import { Button, Row, Col } from "react-bootstrap";
import RequireAuth from "../../../auth/middleware/RequireAuth";

interface MenuTabsProps {
    activeTab: string;
    onTabChange: (key: string) => void;
}

const MenuTabs: React.FC<MenuTabsProps> = ({ activeTab, onTabChange }) => {
    const tabs = [
        { label: "Dashboard", key: "dashboard", permissions: ["cm_report_view"] },
        { label: "Property Report", key: "property", permissions: ["cm_report_property_report"] },
        { label: "Group Report", key: "group", permissions: ["cm_report_group_report"] },
        { label: "Growth Report", key: "growth", permissions: ["cm_report_growth_report"] },
        { label: "Room Report", key: "room", permissions: ["cm_report_room_report"] },
    ];

    return (
        <Row className="justify-content-start gap-2">
            {tabs.map((tab) => (
                <RequireAuth requiredRoles={['dev']} requiredPermissions={tab.permissions} key={tab.key} asComponent>
                    <Col xs="auto">
                        <Button
                            variant={activeTab === tab.key ? "primary" : "outline-primary"}
                            onClick={() => onTabChange(tab.key)}
                        >
                            {tab.label}
                        </Button>
                    </Col>
                </RequireAuth>
            ))}
        </Row>
    );
};

export default MenuTabs;
